"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const flatControlsArray_1 = __importDefault(require("./flatControlsArray"));
const flatTopNavigationBar = ({ topNavigationBar, pageId, initialObject = {}, }) => (0, flatControlsArray_1.default)({
    controls: topNavigationBar.controls,
    parentControlId: topNavigationBar.id,
    initialObject: Object.assign(Object.assign({}, initialObject), { [topNavigationBar.id]: {
            control: topNavigationBar,
            parentControlId: pageId,
            context: { type: 'isPageTopNavBar', pageId },
        } }),
    path: [],
    context: { type: 'pageTopNavControl', pageId },
});
exports.default = flatTopNavigationBar;
